import { render, staticRenderFns } from "./inputPro.vue?vue&type=template&id=48ea193e"
import script from "./inputPro.vue?vue&type=script&lang=js"
export * from "./inputPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports